<p-dialog
  #wlDialog
  modal="true" [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
>
  <ng-template pTemplate="header">
    <h3 class="modal-title">{{ dialog.headerText | uppercase }}</h3>
  </ng-template>

  <p class="wl-dialog-message">
    {{ dialog.messageText }}
  </p>
  <ng-template pTemplate="footer">
    <div class="pull-right" *ngIf="!dialog.showAlert">
      <button pButton type="button" class="btn btn-primary" (click)="dialogYes()">{{ dialog.yesText }}</button>
      <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="dialogNo()">{{ dialog.noText }}</button>
      <button pButton type="button" class="atlas-btn atlas-btn-default" *ngIf="dialog.showCancel" (click)="dialogCancel()">
        {{ dialog.cancelText }}
      </button>
    </div>
    &nbsp;
    <div class="pull-right" *ngIf="dialog.showAlert">
      <button pButton type="button" class="btn btn-primary" (click)="dialogOk()">{{ dialog.okText }}</button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #wlWaitDialog
  modal="true" [(visible)]="showWaitModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [showHeader]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <div style="text-align: center">
    <img src="/assets/img/loading_2x.gif" alt="Loading..." />
  </div>
</p-dialog>

<p-dialog
  #wlErrorDialog
  modal="true" [(visible)]="showErrorModal"
  [closable]="true"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ dialog.headerText | uppercase }}</h4>
  </ng-template>
  <p class="wl-dialog-message">
    {{ dialog.messageText }}
  </p>
  <ng-template pTemplate="footer"
    >&nbsp;
    <button pButton type="button" class="btn btn-primary" (click)="dialogOk()">{{ dialog.okText }}</button>
  </ng-template>
</p-dialog>
